module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "booksection"
  }, [_c('p', {
    staticClass: "img"
  }, [_c('a', {
    attrs: {
      "id": "page6"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p6.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page6"
    }
  }), _c('p', {
    staticClass: "caption1"
  }, [_c('a', {
    attrs: {
      "id": "page6"
    }
  }), _c('span', {
    attrs: {
      "href": "#/cap02#page33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Snickerdoodles (see recipe)")])]), _vm._v(" "), _c('h1', {
    staticClass: "head_a",
    attrs: {
      "id": "ch01"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_vm._v("COOKIE BASICS")])])]), _c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("What could be better than the aroma of freshly baked cookies coming from the oven?")]), _vm._v(" Perhaps only the first sublime bite of a warm chocolate chip cookie with its melted chocolate bits—a moment of pure delight. Cookies evoke so many wonderful emotions; they fill your kitchen with the aromas of childhood and the memories of holiday time. Nothing is more satisfying than dipping a hand into the cookie jar to instantly indulge your sweet tooth.")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_vm._v("The recipes in this book begin with our favorite selection of classic and versatile drop cookies, perfect for any day of the year. Serving these fresh from the oven, like ")]), _c('span', {
    attrs: {
      "href": "#/cap02#page38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Salted-Caramel Chocolate Chip Cookies (see recipe)")]), _vm._v(", will elicit instant smiles. Next come recipes for indulgent bars and tender, buttery sandwich cookies that are all wonderful alternatives to serving cupcakes at parties. Try your hand at "), _c('span', {
    attrs: {
      "href": "#/cap03#page43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Homemade Oreos (see recipe)")]), _vm._v(" for kids (or kids at heart). And finally, 17 festive holiday cookies bring to life dreams of peppermint, gingerbread, rugelach, and a winter wonderland of flavors.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The secret to successful cookie baking starts with the dough, so in the next few pages we cover everything from equipment essentials to rolling, cutting, and shaping dough. Cookie decorating is easily doable with a few basic tools and our handy how-tos. Many of these recipes are simple enough to make that you can enlist little hands to help. And don’t miss our tips for proper storing and beautiful gift giving.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("We celebrate the cookie and all of its different textures—crispy, chewy, or downright gooey—and encourage you to experiment with your favorite flavors and ideas for mix-ins. You’ll find exciting flavor variations throughout, from "), _c('span', {
    attrs: {
      "href": "#/cap04#page75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Matcha Shortbread Cookies (see recipe)")]), _vm._v(" to "), _c('span', {
    attrs: {
      "href": "#/cap04#page94",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Honey & Rose Water Mexican Wedding Cookies (see recipe)")]), _vm._v(". Perhaps you’ll find a new favorite or develop a new holiday tradition. Get creative with whatever shapes, colors, and designs you like. Just don’t forget a big glass of cold milk.")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p8.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page8"
    }
  }), _c('h1', {
    staticClass: "head_a"
  }, [_c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_c('span', {
    staticClass: "bold"
  })]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v("COOKIE BASICS")])]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('p', {
    staticClass: "quote"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("There are several types of cookies—dropped, rolled and cut, pressed, and sandwich—and we love them all. While many do not require any special tools, some might need a specific pan or piece of equipment.")])]), _vm._v(" "), _c('h2', [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Tool Kit")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("In addition to the standard suite of baking tools (mixing bowls, measuring cups, and baking sheets), it’s good to have a few other items on hand before you get started.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("An electric stand mixer is handy for mixing dough, and wire cooling racks are essential for allowing air circulation so that cookies cool quickly and evenly.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Use parchment paper or silicone baking mats to line baking sheets to prevent dough from sticking. And, of course, a rolling pin and a selection of cookie cutters are a must for making Christmas cookies!")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v("For decorating, be sure to have an offset spatula (also called a palette knife) on hand, as well as a piping bag and an array of tips (")]), _c('a', {
    attrs: {
      "href": "#/cap01#page14"
    }
  }, [_vm._v("see recipe for detailed decorating instructions")]), _vm._v("). Gather several small bowls (dishwasher-safe materials make cleanup a breeze) for mixing icing. Small paintbrushes to spread icing, paint designs, and brush on luster dust are also useful.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("You’ll need a cookie press for our "), _c('span', {
    attrs: {
      "href": "#/cap04#page90",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spritz Cookies (see recipe)")]), _vm._v(" and a special madeleine pan for "), _c('span', {
    attrs: {
      "href": "#/cap04#page70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chuck Williams’ own recipe for madeleines (see recipe)")]), _vm._v(".")]), _vm._v(" "), _c('h2', [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Ingredients")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("Most cookie recipes use the same stockpile of ingredients: butter, flour, sugar, eggs, and vanilla or other flavorings. Using the highest quality of each yields the best results. Start out with all your ingredients at room temperature, unless the recipe instructs otherwise. The temperature of the butter is important: if the butter is too cold, it will not fluff up or cream properly, and if it is too warm or nearly melted, it will be too thin to fluff up at all.")]), _vm._v(" "), _c('h2', [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Measuring")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("Professional bakers use a kitchen scale to measure dry ingredients, but most home cooks use cups and spoons. Whichever method you use, be sure to measure precisely and use the same method for the entire recipe.")]), _vm._v(" "), _c('h2', [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Serving")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("From a cookie jar brimming with chocolate chip cookies to a vintage tray stacked with brownies, presentation ideas are endless. Keep in mind that some recipes have specific serving instructions; for example, madeleines are best served warm from the oven, dusted with confectioners’ sugar.")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p12.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }), _c('p', {
    staticClass: "caption1"
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }), _c('span', {
    attrs: {
      "href": "#/cap02#page30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chocolate Florentines (see recipe)")])]), _vm._v(" "), _c('h1', {
    staticClass: "head_a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("COOKIE CARE 101")])])]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('p', {
    staticClass: "quote"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Cookie dough and finished cookies are delicate. It is important to handle cookies with care at every stage of the process—from prepping, rolling, and cutting to cooling, decorating, and storing.")])]), _vm._v(" "), _c('h2', [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Shaping & Freezing")])])]), _c('p', {
    staticClass: "noindent1a"
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("Making great cookies starts with the dough. Temperature is key! For best results, follow the instructions in each recipe regarding chilling and wrapping cookie dough; many require refrigerating the dough for at least 1 hour or up to overnight. Rolled cookie dough should never get too warm or it will spread while baking. When making ")]), _c('span', {
    attrs: {
      "href": "#/cap04#page90",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spritz Cookies (see recipe)")]), _vm._v(", be sure that the dough is at room temperature as it needs to be soft enough to extrude easily from the cookie press. To save time, the dough for some recipes can be prepared ahead and then frozen, as with the "), _c('span', {
    attrs: {
      "href": "#/cap04#page81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Checkerboard Cookies (see recipe)")]), _vm._v(". If working with frozen dough, let it stand at room temperature for a few minutes before shaping or slicing.")]), _vm._v(" "), _c('h2', [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Baking & Cooling")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("Oven temperatures vary, and since cookies have short baking times, it is important to watch them closely so they don’t burn. Check for doneness a couple of minutes before the recipe indicates. To ensure even cooking, rotate the baking sheets halfway through the baking time. Use wire racks for cooling; they allow air to circulate beneath the cookies, which helps them cool quickly and evenly. When making bar cookies, use the size of dish called for in the recipe—using a different size will change the baking time and may affect the texture.")]), _vm._v(" "), _c('h2', [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Storing & Packaging")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("Most cookies will keep well in an airtight container, layered between sheets of parchment paper, at room temperature for a few days. To pack bar treats for picnics and parties, wrap them individually in aluminum foil or waxed paper. A dozen beautifully baked cookies can easily become the perfect hostess or holiday gift. Wrap cookies in waxed paper and place on colorful tissue paper in a sturdy decorative box or metal tin, then tie with festive ribbon.")]), _vm._v(" "), _c('h2', [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Troubleshooting")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "dgr"
  }, [_vm._v("• "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("The cookies spread too much during baking.")])]), _vm._v(" The butter was too soft when added, or the dough was placed on a hot baking sheet.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "dgr"
  }, [_vm._v("• "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("The cookies are burned on the bottom.")])]), _vm._v(" The cookies were too thin, the oven was too hot, the baking sheet was too thin or placed too low in the oven, or the baking sheets were not rotated during baking.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "dgr"
  }, [_vm._v("• "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("The cookies did not bake evenly.")])]), _vm._v(" The baking sheets were not rotated during baking.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "dgr"
  }, [_vm._v("• "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("The cookies fell apart when removed from the baking sheet.")])]), _vm._v(" The cookies were removed from the baking sheet too soon.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "dgr"
  }, [_vm._v("• "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("The cookies stuck to the baking sheet.")])]), _vm._v(" The cookies were not baked long enough or were left too long on the baking sheet.")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('h1', {
    staticClass: "head_a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v("DECORATING PRIMER")])])]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('p', {
    staticClass: "quote"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("While making cookie dough is a science, decorating cookies is definitely an art! So let your creative side shine through (perhaps with a little luster dust), and use our guide to help inspire your masterful creations.")])]), _vm._v(" "), _c('h2', [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Royal Icing")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("It all begins with royal icing. This stiff white icing, made from confectioners’ sugar and egg whites or meringue powder, got its name after it was used to ice Queen Victoria’s white wedding cake celebrating her marriage to Prince Albert in 1840. (See recipe, facing page.)")]), _vm._v(" "), _c('h2', [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Equipment")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("A pastry bag (made from cloth or sturdy plastic) with an assortment of removable tips ranging in sizes, a silicone spatula, and a small offset spatula will make easy work of decorating.")]), _vm._v(" "), _c('h2', [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Food Coloring")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("Liquids, powders, and gels are all used to tint icings and frostings. Gel food coloring is the most concentrated and therefore creates colors that are more vibrant. Also, it won’t thin the icing as much as liquid food coloring, which yields colors that are more pastel-toned. You can use a toothpick to add gel food coloring into the icing bit by bit until you are happy with the color. Start light—a little gel goes a long way, and it is easier to add more coloring than it is to lighten up a dark icing.")]), _vm._v(" "), _c('h2', [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Filling a Pastry Bag")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("Piping tips for pastry bags are available in a variety of sizes and shapes (most common are plain and fluted). The smaller the number, the smaller the hole, but numbering systems vary slightly by brand.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("To fill the pastry bag, firmly push the desired decorating tip down into the small hole in the pastry bag. If you’re using a device called a coupler to hold the tip in place, screw it on tightly. Next, form a cuff by folding down the top one-third of the bag. Place one hand under the cuff. Using a silicone spatula, scoop icing into the bag with the other hand to no more than half full. Then unfold the cuff and push the icing down toward the tip, forcing out any air bubbles, and twist the bag closed where the icing ends. With your dominant hand, hold the bag where you just made the twist. With your nondominant hand, hold the bag near the tip, to help stabilize it, and proceed to pipe.")]), _vm._v(" "), _c('h2', [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Piping & Flooding")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("Bakers use terms like “piping” and “flooding” when giving instructions for decorating cookies. Piping creates an outline at the edge of the cookie and flooding fills in the outline with icing. You can use the same bowl of white or colored royal icing for both. Scoop out about one-third of the icing into a piping bag for piping, and thin the remaining icing slightly for flooding.")]), _vm._v(" "), _c('p', {
    staticClass: "tip"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("TIP")])]), _vm._v(" "), _c('p', {
    staticClass: "tip-text"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Always have extra icing on hand to lighten up a color that became too dark or to remake a color that isn’t right.")])]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p15.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Piping, flooding, and decorating are easy ways to add an elegant finishing touch to your cookies.")])]), _vm._v(" "), _c('p', {
    staticClass: "start1"
  })]), _c('p', {
    staticClass: "bull"
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('span', {
    staticClass: "dgr"
  }, [_vm._v("• "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("To pipe:")])]), _vm._v(" Fit your desired tip into a pastry bag and then fill it with royal icing. Pipe a line of icing as close to the edge of the cookie as possible. Let the outline dry for a few minutes before you begin flooding. Or, skip the flooding and just use the piping bag and some decorations to create your finished design.")])]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "dgr"
  }, [_vm._v("• "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("To flood:")])]), _vm._v(" Thin the royal icing slightly by adding warm water 1 teaspoon at a time until it is just spreadable but not runny. Then use an offset spatula, a small paintbrush, or the back of a spoon to spread enough icing over the cookie to cover it generously. Check the icing for air bubbles and pop any with a toothpick. Let the cookies dry completely before storing or packaging.")]), _vm._v(" "), _c('h2', [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Decorations")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("There are endless choices for decorations, enough to make every cookie unique. A sprinkling of sanding sugar (also called colored sugar crystals) is a simple way to make cookies sparkle, and rainbow nonpareils lend playfulness to any design. Dragées—tiny beads commonly available in silver, gold, and other metallic hues—add instant glamour to any cookie. Luster dust gives a metallic sheen to your icing; mix the powder with a flavoring extract and apply it with a small, clean paintbrush.")]), _vm._v(" "), _c('h2', [_c('span', {
    staticClass: "bold"
  }, [_vm._v("ROYAL ICING")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("4 cups (1 lb/500 g) confectioners’ sugar")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("3 tablespoons meringue powder")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("½ teaspoon extract, such as vanilla or almond (optional)")])]), _vm._v(" "), _c('p', {
    staticClass: "ing"
  }, [_c('span', {
    staticClass: "bolditalic"
  }, [_vm._v("Makes about 3 cups (24 fl oz/750 ml)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("In a large bowl, combine the confectioners’ sugar, meringue powder, ½ cup (125 ml) warm water, and extract (if using). Using an electric mixer on medium speed, beat until the mixture is fluffy yet dense, 7–8 minutes. To thin the icing, use a silicone spatula to stir in more warm water, 1 teaspoon at a time. To test the consistency, drizzle a spoonful of icing into the bowl; a ribbon should remain on the surface for about 5 seconds. Cover and refrigerate airtight for up to 1 week. Stir vigorously just before using.")]), _vm._v(" "), _c('p', {
    staticClass: "tip"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("TIP")])]), _vm._v(" "), _c('p', {
    staticClass: "tip-text"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("To keep the icing from drying out while you’re decorating the cookies, cover the bowls of colored icing with plastic wrap when you’re not using them, or place a damp towel over the electric-mixer bowl that contains the uncolored royal icing.")])]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  })]), _c('p', {
    staticClass: "img"
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p16.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }), _c('h1', {
    staticClass: "head_a"
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('span', {
    staticClass: "bold"
  })]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("TIPS FOR ROLLING & CUTTING DOUGH")])]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('p', {
    staticClass: "quote"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The first few times you work with cookie dough can be tricky. But like other rewarding baking adventures, practice makes perfect—especially if you follow these handy tips.")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "dgr"
  }, [_vm._v("•")]), _vm._v(" When rolling out dough, work quickly so that it doesn’t become too warm. This will help ensure that the cutout shapes don’t spread when they bake. If your kitchen is warm, refrigerate the cutout cookies on a baking sheet for 15 to 20 minutes before putting them in the oven.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "dgr"
  }, [_vm._v("•")]), _vm._v(" Flour your work surface and rolling pin before getting started. Or, if the dough becomes too sticky and tricky, roll it between sheets of waxed or parchment paper.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "dgr"
  }, [_vm._v("•")]), _vm._v(" Dip cookie cutters in flour before pressing them into the dough, and place cookie cutters as close to the edge of the rolled-out dough so you can cut out as many cookies as possible and minimize scraps.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "dgr"
  }, [_vm._v("•")]), _vm._v(" If dough scraps become sticky, refrigerate them for 10 minutes before rerolling. (And resist the temptation to roll the same piece of dough more than twice.)")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "dgr"
  }, [_vm._v("•")]), _vm._v(" If you can’t find the right cookie cutter, trace or print your favorite design on card stock and cut it out with scissors. Then place this template directly on the rolled-out dough and cut out shapes with the tip of a paring knife.")])]), _c('p', {
    staticClass: "bull"
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('span', {
    staticClass: "dgr"
  }, [_vm._v("•")]), _vm._v(" For special occasions, make a big impact by using cookie cutters in the same shape but in an assortment of sizes. Try this with ")]), _c('span', {
    attrs: {
      "href": "#/cap04#page85",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gingerbread People (see recipe")]), _vm._v(") during the holidays. Be sure to group similar sizes together on separate sheets so they bake evenly.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ff3c93d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cap01.vue
// module id = 69
// module chunks = 0